import { createAction } from '@reduxjs/toolkit';
import { TIngredientType } from '../../utils/types';

export const getItemRequest = createAction('items/GET_REQUEST');
export const getItemsSuccess = createAction<
    Array<TIngredientType>,
    'items/GET_SUCCESS'
>('items/GET_SUCCESS');
export const getItemsFailed = createAction<string, 'items/GET_FAILED'>(
    'items/GET_FAILED'
);

export type TGetActions =
    | ReturnType<typeof getItemRequest>
    | ReturnType<typeof getItemsSuccess>
    | ReturnType<typeof getItemsFailed>;
